import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ApisService } from 'src/app/services/apis.service';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.scss']
})
export class CitiesComponent implements OnInit {

  @Output() sendDetails = new EventEmitter<any>();

  cities: any[] = [];
  dummy = Array(10);
  dummyList: any[] = [];
  selectedCity: any;
  constructor(
    private api: ApisService,
    private util: UtilService,
    private router: Router,
    private translate: TranslateService,
  ) {
    const lng = localStorage.getItem('language');
    if (!lng || lng === null) {
      localStorage.setItem('language', 'en');
    }
    this.translate.use(localStorage.getItem('language'));
    this.getCities();
  }
  getCities() {
    this.api.getCities().then((data) => {
      console.log(data);
      this.dummy = [];
      if (data && data.length) {
        data.forEach(element => {
          if (element && element.status === 'active') {
            this.cities.push(element);
            this.dummyList.push(element);
          }
        });
      }
      this.util.hideLoader();
    }).catch(error => {
      console.log(error);
      this.util.errorToast(this.util.translate('Something went wrong'));
      this.dummy = [];
      this.util.hideLoader();
    });
  }

  ngOnInit() {
    this.util.showLoader();
  }

  goNext() {
    console.log('next', this.selectedCity);
    const data = this.cities.filter(x => x.id === this.selectedCity);
    console.log(data);
    localStorage.setItem('selectedCity', JSON.stringify(data[0]));
    this.util.publishLocation('data');
    this.sendDetails.emit();
    this.router.navigate(['home']);
  }
  getClassName() {
    return localStorage.getItem('language');
  }
  changeLng(lng) {
    localStorage.setItem('language', lng);
    this.translate.use(lng);
  }
}
